import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../../components/Layout';
import StudentApplications from './Applications';
import MyScholarships from './MyScholarships';
import Exemptions from './Exemptions';
const ApplicationsAndScholarships: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'applications' | 'scholarships' | 'exemptions'>('applications');
  // Set the active tab based on URL query parameter
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') as 'applications' | 'scholarships' | 'exemptions';
    if (tab && (tab === 'applications' || tab === 'scholarships' || tab === 'exemptions')) {
      setActiveTab(tab);
    }
  }, [location]);
  // Update URL when tab changes
  const handleTabChange = (tab: 'applications' | 'scholarships' | 'exemptions') => {
    setActiveTab(tab);
    navigate(`/student/applications-and-scholarships?tab=${tab}`, {
      replace: true
    });
  };
  return <Layout title="" persona="Student" data-id="element-3738">
      <div data-id="element-3739">
        <h1 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-3740">
          My Applications
        </h1>
        {/* Tabs */}
        <div className="mb-6 border-b border-gray-200" data-id="element-3741">
          <div className="flex space-x-8" data-id="element-3742">
            <button onClick={() => handleTabChange('applications')} className={`py-4 px-1 font-medium text-sm border-b-2 ${activeTab === 'applications' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3743">
              Program Applications
            </button>
            <button onClick={() => handleTabChange('scholarships')} className={`py-4 px-1 font-medium text-sm border-b-2 ${activeTab === 'scholarships' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3744">
              Scholarship Applications
            </button>
            <button onClick={() => handleTabChange('exemptions')} className={`py-4 px-1 font-medium text-sm border-b-2 ${activeTab === 'exemptions' ? 'border-primary-500 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-3745">
              Exemption Requests
            </button>
          </div>
        </div>
        {/* Content */}
        <div className="mt-6" data-id="element-3746">
          {activeTab === 'applications' ? <div className="applications-tab" data-id="element-3747">
              <StudentApplications isTabbed={true} data-id="element-3748" />
            </div> : activeTab === 'scholarships' ? <div className="scholarships-tab" data-id="element-3749">
              <MyScholarships isTabbed={true} data-id="element-3750" />
            </div> : <div className="exemptions-tab" data-id="element-3751">
              <Exemptions isTabbed={true} data-id="element-3752" />
            </div>}
        </div>
      </div>
    </Layout>;
};
export default ApplicationsAndScholarships;